module.exports = __webpack_public_path__ + "img/special-blue.1729dce9.svg";